import { FDIcon } from '@facet-wealth/design';
import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';

export const AccountInstitutionStatusIndicator = ({ resource, alwaysCircleIcon, size }) => {
  const iconColor = resource.withRelationship(fr.relationships.actionLink.name, (rel) => rel.meta('iconColor'), () => 'warning');

  let icon = 'circle';
  if (!alwaysCircleIcon && iconColor.includes('success')) {
    icon = 'link';
  }
  if (!alwaysCircleIcon && iconColor.includes('warning')) {
    icon = 'linkOff';
  }
  return (
    <FDIcon
      color={iconColor ?? 'primary'}
      icon={icon}
      size={size}
      alignSelf={'center'}
    />
  );
};

AccountInstitutionStatusIndicator.propTypes = {
  size: PropTypes.string.isRequired,
  resource: PropTypes.object.isRequired, // linkedInstitution resource
  alwaysCircleIcon: PropTypes.bool.isRequired,
};
